/* unplugin-vue-components disabled */import { render } from "./CollectUserCert.vue?vue&type=template&id=ad1a7c9c&scoped=true"
import script from "./CollectUserCert.vue?vue&type=script&lang=js"
export * from "./CollectUserCert.vue?vue&type=script&lang=js"

import "./CollectUserCert.vue?vue&type=style&index=0&id=ad1a7c9c&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad1a7c9c"]])

export default __exports__